import { useEffect, useState } from "react";
import useAxios from "../../../../Utils/useAxios";
import DeleteUMKModal from "../components/DeleteUMKModal";
import EditStatusUMKModal from "../components/EditStatusUMKModal";
import { STATUS_DATA_TYPE } from "../../../../Constant/StatusData";
import SubHeaderComponent from "../../../DataTableComponents/commonSubHeaderComponent";
import {
  filterBetweenDate,
  filterSearch,
  filterStatus,
} from "../../../../Utils/FilterItems";
import { useThemeContext } from "../../../../Context/ThemeContext";
import FeatureContainer from "../../../../Layout/Containers/FeatureContainer";
import CreateButton from "../../../../CommonElements/Button/CreateButton";
import { FEATURE_FUNCTION_SELECTION } from "../../../../Constant/FeatureSelection";
import ListUMK from "../components/ListUMK";
import getUMKColumns from "../constants/getUMKColumns";
import { getUMK, getUnitKerja } from "../services";
import getUMKCheck from "../services/getUMKCheck";
import { toast } from "react-toastify";
import { timeToast } from "../../../../Constant";
import { Navigate, useLocation } from "react-router-dom";

const UangMukaKegiatan = () => {
  const axiosInstance = useAxios();

  const [data, setData] = useState({ umkList: [], unitKerja: [] });

  const [pending, setPending] = useState({
    umk: false,
    status: false,
  });
  const [redirectPath, setRedirectPath] = useState(null);
  const [totalUMK, setTotalUMK] = useState(0);
  const [selectedUMK, setSelectedUMK] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [selectedStatusUM, setSelectedStatusUM] = useState("");
  const [selectedFilterUnitKerja, setSelectedFilterUnitKerja] = useState("");
  const [selectedFilterTanggal, setSelectedFilterTanggal] = useState("");

  const [isButtonActive, setIsButtonActive] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [editStatusModalOpen, setEditStatusModalOpen] = useState(false);
  const toggleEditStatusModal = () =>
    setEditStatusModalOpen(!editStatusModalOpen);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const toggleDeleteModal = () => setDeleteModalOpen(!deleteModalOpen);

  const { themeContext } = useThemeContext();
  const location = useLocation();

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      await refreshUMK();

      const { data: unitKerjaData } = await getUnitKerja(axiosInstance);
      setData((prev) => ({ ...prev, unitKerja: unitKerjaData }));
    };

    if (isMounted) fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    checkForm();
  }, [data.umkList]);

  useEffect(() => {
    const filteredUMK = filterUMKItems(data.umkList);
    let total = 0;
    filteredUMK.forEach((item) => {
      total += parseFloat(item.nilai);
    });
    setTotalUMK(total);
  }, [data.umkList, filterUMKItems]);

  const refreshUMK = async () => {
    setPending((prev) => ({
      ...prev,
      umk: true,
      status: true,
    }));

    const { data: umkData } = await getUMK(axiosInstance).finally(() =>
      setPending((prev) => ({ ...prev, umk: false, status: false }))
    );
    setData((prev) => ({ ...prev, umkList: umkData }));
    return umkData;
  };

  const checkForm = () => {
    if (data.umkList.dibayarkan_ke !== "") {
      return;
    }
    setIsButtonActive(!isButtonActive);
  };

  const handleEditStatusUMK = (umk) => {
    setSelectedUMK(umk);
    toggleEditStatusModal();
  };

  const handleDeleteUMK = async (umk) => {
    setSelectedUMK(umk);
    toggleDeleteModal();
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const filterUMKItems = (items) => {
    const searchCategories = [
      "diajukan_oleh",
      "id_unit_kerja",
      "kode_umk",
      "keterangan",
    ];
    const filteredItems = items
      .filter(filterSearch(searchCategories, filterText))
      .filter(filterSearch(["id_unit_kerja"], selectedFilterUnitKerja))
      .filter(filterStatus("id_status_umk", selectedStatusUM))
      .filter(
        filterBetweenDate(
          "tanggal_mulai",
          "tanggal_selesai",
          selectedFilterTanggal
        )
      );

    return filteredItems;
  };

  const checkCreateButton = async () => {
    const eligible = await getUMKCheck(axiosInstance);
    if (eligible.status === 200) {
      toast.error(`Selesaikan Pertanggungjawaban Pengajuan Terkahir`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    } else if (eligible.status === 204) {
      setRedirectPath(`${process.env.PUBLIC_URL}/umk/formumk`);
    }
  };

  const subHeaderComponent = (
    <SubHeaderComponent
      filterText={filterText}
      setFilterText={setFilterText}
      handleClear={handleClear}
      setSelectedStatus={setSelectedStatusUM}
      setSelectedFilterUnitKerja={setSelectedFilterUnitKerja}
      setSelectedFilterTanggal={setSelectedFilterTanggal}
      unitKerja={data.unitKerja}
      statusDataType={STATUS_DATA_TYPE.UMK}
    />
  );

  if (redirectPath) {
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  return (
    <FeatureContainer
      title={"Uang Muka Kegiatan"}
      statusList={filterUMKItems(data.umkList)}
      pending={pending?.status}
      refreshList={refreshUMK}
      createButton={
        FEATURE_FUNCTION_SELECTION.UMK.Create && (
          <CreateButton toggle={() => checkCreateButton()}>
            Buat UMK
          </CreateButton>
        )
      }
    >
      <ListUMK
        data={filterUMKItems(data.umkList)}
        columns={getUMKColumns({
          themeContext,
          handleEditStatusUMK,
          handleDeleteUMK,
        })}
        totalUMK={totalUMK}
        subHeaderComponent={subHeaderComponent}
        pending={pending?.umk}
        resetPaginationToggle={resetPaginationToggle}
      />
      {selectedUMK && (
        <EditStatusUMKModal
          editStatusModalOpen={editStatusModalOpen}
          toggleEditStatusModal={toggleEditStatusModal}
          selectedUMK={selectedUMK}
          refreshUMK={refreshUMK}
          axiosInstance={axiosInstance}
        />
      )}
      {selectedUMK && (
        <DeleteUMKModal
          deleteModalOpen={deleteModalOpen}
          toggleDeleteModal={toggleDeleteModal}
          selectedUMK={selectedUMK}
          refreshUMK={refreshUMK}
          axiosInstance={axiosInstance}
        />
      )}
    </FeatureContainer>
  );
};

export default UangMukaKegiatan;
